$(function () {
  $(".js-fadeUp").on("inview", function () {
    var self = $(this);
    setTimeout(function() {
      self.addClass("is-fadeUp");
    }, 500);
  });

  $(".js-fade").on("inview", function () {
    $(this).addClass("is-fadein");
  });

  $(".js-band").on("inview", function () {
    var self = $(this);
    setTimeout(function() {
      self.addClass("is-band");
    }, 300);
  });

  $(".js-fadeUp-late").on("inview", function () {
    var self = $(this);
    setTimeout(function() {
      self.addClass("is-fadeUp");
    }, 800);
  });

  $(".js-fadeUp-fast").on("inview", function () {
    $(this).addClass("is-fadeUp");
  });
});
